import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Link,
  Container,
  Flex,
  Icon,
  Stack,
  Spacer,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { MdDelete } from "react-icons/md";

const List = ({ list, handleDelete }) => {
  const bgColor = useColorModeValue("gray.100", "gray.700");
  return (
    <Flex bg={bgColor} px={5} py={3} borderRadius="md" boxShadow="md">
      <Box fontWeight="bold">
        <Text fontSize="lg">
          <Link as={RouterLink} to={list.id}>
            {list.title}
          </Link>
        </Text>
        <Text color="gray.600" fontSize={"sm"}>
          {Object.keys(list.todos).length} TASKS
        </Text>
      </Box>
      <Spacer />
      <Icon
        as={MdDelete}
        _hover={{ color: "red.400" }}
        w={6}
        h={6}
        cursor="pointer"
        onClick={() => handleDelete(list.id)}
      />
    </Flex>
  );
};

const Lists = ({ lists, handleDelete }) => {
  return (
    <Container py={5}>
      <Stack direction="column" spacing={3}>
        {lists.map((list) => (
          <List key={list.id} list={list} handleDelete={handleDelete} />
        ))}
      </Stack>
    </Container>
  );
};

export default Lists;
